import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { signInReset } from '@zocdoc-frontend-common/components-sign-in-form/signInFormActions';
import { LOGIN_STATE } from '@zocdoc-frontend-common/state-user-account/constants';
import {
    loginStateSelector,
    userSelector,
} from '@zocdoc-frontend-common/state-user-account/selectors';
import { recordAssignmentsOnMount } from '@zocdoc-frontend-common/utils-ab';
import {
    VARIANT_ON,
    PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP,
    PINATA_REMOVE_UPCOMING_APPT_PAGE,
    PINATA_MFA_AUTH,
} from '@zocdoc-frontend-common/utils-ab/constants';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import MobileMenu from './MobileMenu';

export function mapStateToProps(state) {
    const loginState = loginStateSelector(state);
    const hardOrSoftLoggedIn =
        loginState === LOGIN_STATE.LoggedIn ||
        loginState === LOGIN_STATE.SoftLoggedIn;
    return {
        isMfaEnabled: state.signInForm?.isMfaEnabled,
        isUserLocked: state.signInForm?.isUserLocked,
        signedIn: hardOrSoftLoggedIn,
        suggestedRedirect: state.signInForm?.suggestedRedirect,
        user: userSelector(state),
        isInEmailFirstLoginAndSignup:
            state.absystem?.[
                PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP.experimentId
            ] === VARIANT_ON,
        shouldHideUpcomingApptsLink:
            state.absystem?.[PINATA_REMOVE_UPCOMING_APPT_PAGE.experimentId] ===
            VARIANT_ON,
    };
}

const mapDispatchToProps = {
    resetLoginForm: signInReset,
};

export default flowRight(
    withCustomMetrics({
        component: 'MobileMenu',
    }),
    connect(mapStateToProps, mapDispatchToProps),
    recordAssignmentsOnMount([
        PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP,
        PINATA_REMOVE_UPCOMING_APPT_PAGE,
        PINATA_MFA_AUTH,
    ])
)(MobileMenu);
